export const LOADED = '@initial/LOADED';